const config = {
  authRealm: process.env.uvote2.counting,
  authUrl: process.env.https://authuvote.prod.cineca.it/auth,
  authClientId: process.env.uvote-counting,
  credentials: {
    secret: process.env.71gdienjnpKo7qVb2lr5z1ZGbFMknjy4
  },

  logoutRedirectUri: process.env.https://uvote2-webcounting.prod.cineca.it/
};

export default config;
